import NavLink from '../shared/buttons/nav-link';
import Segment from '../shared/segment';

export type PaymentFailurePropsType = {
  code: string;
  error: string;
};

function PaymentFailure({ code, error }: PaymentFailurePropsType) {
  return (
    <Segment color='red' textAlign='center' className='text-xl'>
      <p>متاسفانه تراکنش ناموفق بود.</p>
      {code && (
        <p className='my-2'>
          <span>کد خطا: </span>
          <span className='plain-text'>{code}</span>
        </p>
      )}
      {error && (
        <div className='my-2'>
          <p>خطا: </p>
          <p>{error}</p>
        </div>
      )}
      <NavLink to='/exams' color='green' content='بازگشت' className='mx-auto my-6' />
    </Segment>
  );
}

export default PaymentFailure;
